import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { PageLastScore } from '../models/PageLastScore';



@Injectable()
export class WebVitalsService {
  private apiUrl = APP_SETTINGS.WebVitalsApiUrl;

  constructor(
    private executeService: ExecuteService,
    
    private errorHandler: ErrorHandlerService) { }

  public Get(): Observable<PageLastScore[]> {
    const url = `${this.apiUrl}/api/v1/page/lastScores`;

    return this.executeService.ExecuteWithApiToken('get', url)
      .pipe(
        catchError(this.errorHandler.handleError<string[]>('WebVitalsService_Get', [], true))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/webVitals/services/WebVitals.service.ts